import HTTP from '../HTTP';

const URL_BASE = 'gescom/RemiseBancaire/';

export async function getAll(remiseBancaireFilter) {
  const response = await HTTP.post(URL_BASE + 'PGetAllAsync', remiseBancaireFilter);
  return response;
}

export async function remove(id) {
  const response = await HTTP.delete(URL_BASE + 'DeleteAsync', { params: { id } });
  return response;
}
export async function create(parameters) {
  const response = await HTTP.post(URL_BASE + 'CreateAsync', parameters);
  return response;
}

export async function get(id) {
  const response = await HTTP.get(URL_BASE + 'GetAsync', { params: { id } });
  return response;
}

export async function deleteLotPaiementEnCours(id, avecFacturesAchat, listeMouvementId) {
  const response = await HTTP.post(URL_BASE + 'PDeleteLotPaiementEnCoursAsync', { id, listeMouvementId }, {
    params: {
      avecFacturesAchat,
    },
  });
  return response;
}

export async function valid(id) {
  const response = await HTTP.post(URL_BASE + 'PValidateAsync', { id });
  return response;
}

export async function unValid(id) {
  const response = await HTTP.post(URL_BASE + 'PUnValidateAsync', { id });
  return response;
}

export async function update(param) {
  const response = await HTTP.put(URL_BASE + 'UpdateAsync', param);
  return response;
}

export async function virementsSEPA(id) {
  const response = await HTTP.post(URL_BASE + 'VirementsSEPAAsync', { id });
  return response;
}
export async function prelevementSEPA(id) {
  const response = await HTTP.post(URL_BASE + 'PrelevementSEPAAsync', { id });
  return response;
}
